import { PersonnelApi, TagApi } from '@wiz-api/personnel-position'
import {
  get,
  isEmpty,
  map,
  filter,
  find,
  remove,
  forEach,
  cloneDeep,
  some,
  uniq,
  concat,
} from 'lodash'

const personnelApi = new PersonnelApi()
const tagApi = new TagApi()
// 读取websocket连接地址
const socketPath =
  get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
    ?.PersonnelPositionPath || ''
// 全部人员列表（不管在不在线）
let personnelList = []
// 当前在线的列表
let onlineTagList = []
// 当前需要更新的实时定位数据
let currentPositionList = []
// 当前已经加载并且显示的人员
let currentVisiblePerson = []
let socketObject = null
// 在当前区域的tagId的数组
let filterTagList = []
// 是否在区域中进行筛选
let isInAera = false
// 所有创建过的人员
let allDataList = []
// 所有的标签
let allTag = []
// 销毁的标识
let isDestroy = false
let cloudRender
let sceneId = ''
// rgba转换为十六进制
const translateColor = (rgbaString) => {
  // 利用正则表达式匹配出RGBA中的R、G、B和A通道的值
  const values = rgbaString.match(/\d+(\.\d+)?/g)
  const r = parseInt(values[0], 10)
  const g = parseInt(values[1], 10)
  const b = parseInt(values[2], 10)
  const a = parseFloat(values[3])

  // 将R、G、B三个颜色通道的值转换为十六进制，并补齐到两位
  const rHex = r.toString(16).padStart(2, '0')
  const gHex = g.toString(16).padStart(2, '0')
  const bHex = b.toString(16).padStart(2, '0')

  // 将A通道的值转换为十六进制，并补齐到两位
  const aHex = Math.round(a * 255)
    .toString(16)
    .padStart(2, '0')

  // 拼接R、G、B、A四个通道的十六进制数值
  const hexColor = `#${rHex}${gHex}${bHex}${aHex}`

  return hexColor
}
// 初始化数据
const initData = () => {
  personnelList = []
  onlineTagList = []
  currentPositionList = []
  currentVisiblePerson = []
  filterTagList = []
  isInAera = false
  allDataList = []
  allTag = []
  sceneId = ''
  socketObject = null
  isDestroy = false
}

// 打开人员详情
const openPersonnelDetail = async (personnelId, tagCode) => {
  if (!personnelId || !tagCode) {
    return
  }
  // 跟随人员
  await cloudRender.PosViewer.setPerspectiveFollow({
    id: tagCode,
    personalPerspective: 2,
    angle: [5, 90],
  })
  const openEvent = new CustomEvent('openComponent', {
    detail: {
      toCom: {
        code: 'PlantPerson',
        origin: 'tag',
        name: '人员信息',
      },
      type: 'tags',
      props: {
        personnelId,
        tagCode,
      },
    },
  })
  window.dispatchEvent(openEvent)
}

// 连接websocket
const connetSocket = async () => {
  // const res = {
  //   positionList: [],
  //   onLineList: [
  //     {
  //       tagId: '50016',
  //       mapId: '1',
  //       positionTime: '2024-11-27 11:04:02',
  //       systemTime: '2024-11-27 11:09:30',
  //       x: 76.3134306404,
  //       y: 14.356908847,
  //       z: 1.4945021328,
  //       isNew: true
  //     },
  //     {
  //       tagId: '50005',
  //       mapId: '2',
  //       positionTime: '2024-11-27 11:04:02',
  //       systemTime: '2024-11-27 11:09:30',
  //       x: 76.3134306404,
  //       y: 19.356908847,
  //       z: 1.4945021328,
  //       isNew: true
  //     },
  //   ],
  //   time: '0001-01-01 00:00:00',
  //   offLineTime: 0
  // }
  // // 两种情况：res.positionList和res.onLineList只有一个有值
  // if (!isEmpty(res) && isEmpty(res.positionList) && !isEmpty(res.onLineList)) {
  //   // res.onLineList有值的时候onlineTagList筛选出设置了标签的人员
  //   onlineTagList = filter(res.onLineList, (el) => {
  //     return find(personnelList, ['tagCode', el.tagId])
  //   })
  //   // 添加名字字段
  //   forEach(onlineTagList, (item) => {
  //     const personDetail = find(personnelList, ['tagCode', item.tagId])
  //     if (!isEmpty(personDetail)) {
  //       item.name = personDetail.name
  //     }
  //   })
  //   // 应急处置卡数据需要
  //   const copyOnlineTagList = JSON.parse(JSON.stringify(onlineTagList))
  //   forEach(onlineTagList, (item) => {
  //     const personDetail = find(copyOnlineTagList, ['tagCode', item.tagId])
  //     if (!isEmpty(personDetail)) {
  //       item.name = personDetail.name
  //       item.id = personDetail.id
  //     }
  //   })
  //   // 缓存在线人员列表给应急处置卡 组件第一次进入数据获取
  //   sessionStorage.setItem('onlineTagList', JSON.stringify(copyOnlineTagList))
  //   const openEvent = new CustomEvent('onlineTagList', {
  //     detail: {
  //       copyOnlineTagList,
  //     },
  //   })
  //   window.dispatchEvent(openEvent)
  //   // 与之前创建完成人员相比，筛选出消失的人员
  //   const hiddenList = remove(currentVisiblePerson, (el) => {
  //     return !find(onlineTagList, ['tagId', el])
  //   })
  //   // 把消失的人员隐藏
  //   if (!isEmpty(hiddenList)) {
  //     cloudRender.PosViewer.setPosViewerVisible(hiddenList, false)
  //   }
  //   // 需要创建的人员列表（新进来的人员的isNew为true）
  //   const createArr = map(
  //     filter(onlineTagList, (el) => {
  //       // isNew并且没有创建过
  //       return (
  //         el.isNew &&
  //         !some(allDataList, (it) => {
  //           return it === el.tagId
  //         })
  //       )
  //     }),
  //     (item) => {
  //       const currentTag = find(allTag, (tag) => {
  //         return tag.tagCode === item.tagId
  //       })
  //       const background = currentTag?.color ? translateColor(currentTag.color) : '#2196f3'
  //       return {
  //         id: item.tagId,
  //         position: [item.x, item.y, item.z],
  //         capType: 'blue',
  //         markerOption: {
  //           background,
  //           text: item.name,
  //           markPosType: 4,
  //           nodeOffset: [0, -5],
  //         },
  //       }
  //     }
  //   )
  //   // 重新上线的人员
  //   const reshowList = map(
  //     filter(onlineTagList, (el) => {
  //       // 临时下线了
  //       return (
  //         el.isNew &&
  //         !some(currentVisiblePerson, (it) => {
  //           return it === el.tagId
  //         }) &&
  //         some(allDataList, (i) => {
  //           return i === el.tagId
  //         })
  //       )
  //     }),
  //     (item) => {
  //       return item.tagId
  //     }
  //   )
  //   // 临时下线的人员再次上线
  //   await cloudRender.PosViewer.setPosViewerVisible(reshowList, true)
  //   currentVisiblePerson = uniq(concat(currentVisiblePerson, reshowList))
  //   // 批量创建人员
  //   const createdResult = await cloudRender.PosViewer.createPosViewer(createArr)
  //   if (createdResult.status && !isEmpty(createdResult.data)) {
  //     const ids = createdResult.data.map((item) => {
  //       return item.id
  //     })
  //     if (isDestroy) {
  //       await cloudRender.PosViewer.destroyPosviewer(ids)
  //     } else {
  //       currentVisiblePerson = uniq(concat(currentVisiblePerson, ids))
  //       // 把所有创建过的人存起来
  //       allDataList = uniq(concat(allDataList, currentVisiblePerson))
  //       console.log(allDataList, 'allDataList')
  //     }
  //   }
  // } else {
  //   // res.positionList有值的时候修改人员位置
  //   // 当前需要显示的人员：筛选出已经创建并且绑定了标签的人员
  //   // 更新区域中的实时定位数据
  //   const filterPositionList = filter(res.positionList, (el) => {
  //     return (
  //       find(personnelList, ['tagCode', el.tagId]) &&
  //       find(currentVisiblePerson, (item) => {
  //         return item === el.tagId
  //       })
  //     )
  //   })
  //   const positionEvent = new CustomEvent('setPositionList', {
  //     detail: {
  //       position: filterPositionList,
  //     },
  //   })
  //   window.dispatchEvent(positionEvent)
  //   currentPositionList = filter(filterPositionList, (el) => {
  //     return (
  //       // 如果需要在区域中筛选
  //       !isInAera ||
  //       some(filterTagList, (item) => {
  //         return item === el.tagId
  //       })
  //     )
  //   })
  //   // 批量设置位置
  //   await cloudRender.PosViewer.setPosition(
  //     map(currentPositionList, (item) => {
  //       return {
  //         id: item.tagId,
  //         position: [item.x, item.y, item.z],
  //       }
  //     })
  //   )
  // }
  // return
  const socketUrl = `${socketPath}/Position?modelId=${sceneId}&siteId=3a0743fd-2f61-51c2-3bfd-415e973ef230`
  // const socketUrl =
  //   'ws://devaspnetcore02.wiz.top:4547/Position?modelId=3a0f5919-b640-f2f2-30e6-323c5865e1d3&siteId=3a0743fd-2f61-51c2-3bfd-415e973ef230'
  socketObject = new WebSocket(socketUrl)
  socketObject.onopen = () => {
    // console.log('人员服务连接成功！')
  }
  socketObject.onmessage = async ({ data }) => {
    if (data.indexOf('连接成功') === 0) {
    } else {
      const res = JSON.parse(data)
      // 两种情况：res.positionList和res.onLineList只有一个有值
      if (!isEmpty(res) && isEmpty(res.positionList) && !isEmpty(res.onLineList)) {
        // res.onLineList有值的时候onlineTagList筛选出设置了标签的人员
        onlineTagList = filter(res.onLineList, (el) => {
          return find(personnelList, ['tagCode', el.tagId])
        })
        // 添加名字字段
        forEach(onlineTagList, (item) => {
          const personDetail = find(personnelList, ['tagCode', item.tagId])
          if (!isEmpty(personDetail)) {
            item.name = personDetail.name
          }
        })
        // 应急处置卡数据需要
        const copyOnlineTagList = JSON.parse(JSON.stringify(onlineTagList))
        forEach(onlineTagList, (item) => {
          const personDetail = find(copyOnlineTagList, ['tagCode', item.tagId])
          if (!isEmpty(personDetail)) {
            item.name = personDetail.name
            item.id = personDetail.id
          }
        })
        // 缓存在线人员列表给应急处置卡 组件第一次进入数据获取
        sessionStorage.setItem('onlineTagList', JSON.stringify(copyOnlineTagList))
        const openEvent = new CustomEvent('onlineTagList', {
          detail: {
            copyOnlineTagList,
          },
        })
        window.dispatchEvent(openEvent)
        // 与之前创建完成人员相比，筛选出消失的人员
        const hiddenList = remove(currentVisiblePerson, (el) => {
          return !find(onlineTagList, ['tagId', el])
        })
        // 把消失的人员隐藏
        if (!isEmpty(hiddenList)) {
          cloudRender.PosViewer.setPosViewerVisible(hiddenList, false)
        }
        // 需要创建的人员列表（新进来的人员的isNew为true）
        const createArr = map(
          filter(onlineTagList, (el) => {
            // isNew并且没有创建过
            return (
              el.isNew &&
              !some(allDataList, (it) => {
                return it === el.tagId
              })
            )
          }),
          (item) => {
            const currentTag = find(allTag, (tag) => {
              return tag.tagCode === item.tagId
            })
            const background = currentTag?.color ? translateColor(currentTag.color) : '#2196f3'
            return {
              id: item.tagId,
              position: [item.x, item.y, item.z],
              markerOption: {
                background,
                text: item.name,
                markPosType: 4,
                nodeOffset: [0, -5],
              },
            }
          }
        )
        // 重新上线的人员
        const reshowList = map(
          filter(onlineTagList, (el) => {
            // 临时下线了
            return (
              el.isNew &&
              !some(currentVisiblePerson, (it) => {
                return it === el.tagId
              }) &&
              some(allDataList, (i) => {
                return i === el.tagId
              })
            )
          }),
          (item) => {
            return item.tagId
          }
        )
        // 临时下线的人员再次上线
        await cloudRender.PosViewer.setPosViewerVisible(reshowList, true)
        currentVisiblePerson = uniq(concat(currentVisiblePerson, reshowList))
        // 批量创建人员
        const createdResult = await cloudRender.PosViewer.createPosViewer(createArr)
        if (createdResult.status && !isEmpty(createdResult.data)) {
          if (isDestroy) {
            await cloudRender.PosViewer.destroyPosviewer(createdResult.data)
          } else {
            currentVisiblePerson = uniq(concat(currentVisiblePerson, createdResult.data))
            // 把所有创建过的人存起来
            allDataList = uniq(concat(allDataList, currentVisiblePerson))
          }
        }
      } else {
        // res.positionList有值的时候修改人员位置
        // 当前需要显示的人员：筛选出已经创建并且绑定了标签的人员
        // 更新区域中的实时定位数据
        const filterPositionList = filter(res.positionList, (el) => {
          return (
            find(personnelList, ['tagCode', el.tagId]) &&
            find(currentVisiblePerson, (item) => {
              return item === el.tagId
            })
          )
        })
        const positionEvent = new CustomEvent('setPositionList', {
          detail: {
            position: filterPositionList,
          },
        })
        window.dispatchEvent(positionEvent)
        currentPositionList = filter(filterPositionList, (el) => {
          return (
            // 如果需要在区域中筛选
            !isInAera ||
            some(filterTagList, (item) => {
              return item === el.tagId
            })
          )
        })
        // 批量设置位置
        await cloudRender.PosViewer.setPosition(
          map(currentPositionList, (item) => {
            return {
              id: item.tagId,
              position: [item.x, item.y, item.z],
            }
          })
        )
      }
    }
  }
  socketObject.oncolse = () => {
    // console.log('连接断开---')
  }
  socketObject.onerror = () => {
    // console.log('连接断开---')
  }
}

// 获取人员列表
const getPersonnelList = async () => {
  const [err, res] = await personnelApi.getPersonnelPostionList({
    isBind: true,
    skipCount: 0,
    maxResultCount: 1000,
  })
  if (!err && !isEmpty(res)) {
    personnelList = res
  }
}

// 获取所有标签
const getAllTag = async () => {
  const [err, res] = await tagApi.getTagList({
    keyword: '',
    type: '',
    departmentId: '',
    maxResultCount: 1000,
    skipCount: 0,
  })
  if (!err && !isEmpty(res)) {
    allTag = res.items
  }
}

// 标签事件
const markerClick = (e) => {
  // 左键点击并且有id
  if (!isEmpty(e?.id)) {
    const currentPersonnel = find(personnelList, ['tagCode', e.id])
    if (!isEmpty(currentPersonnel)) {
      openPersonnelDetail(currentPersonnel.id, e.id)
    }
  }
}

const filterPositionHandler = (e) => {
  filterTagList = cloneDeep(e.detail.tagIdList)
  isInAera = true

  // 隐藏不在当前区域的人员
  forEach(currentVisiblePerson, (item) => {
    // 如果在区域中则显示，不在则隐藏
    if (
      !some(filterTagList, (i) => {
        return i === item
      })
    ) {
      cloudRender.PosViewer.setPosViewerVisible(item, false)
    } else {
      cloudRender.PosViewer.setPosViewerVisible(item, true)
    }
  })
}

const operateSocketHandler = async (e) => {
  if (e.detail) {
    if (e.detail.type) {
      connetSocket()
      cloudRender.PosViewer.setPosViewerVisible(currentVisiblePerson, true)
    } else {
      // 断开websocket连接
      if (!isEmpty(socketObject)) {
        socketObject.close()
      }
      // 隐藏所有人员
      cloudRender.PosViewer.setPosViewerVisible(currentVisiblePerson, false)
    }
  }
}

// 创建人员
const create = async (player, propSceneId, propCloudRender) => {
  if (!player.Native) {
    return
  }
  // 初始化数据
  initData()
  cloudRender = propCloudRender
  sceneId = propSceneId
  await getPersonnelList()
  await getAllTag()
  connetSocket()
  cloudRender.Dispatch.on('PosViewerMarker', markerClick)
  window.addEventListener('filterPositionList', filterPositionHandler)

  window.addEventListener('operateSocket', operateSocketHandler)
}
// 销毁人员
const destroy = async (player) => {
  // 断开websocket连接
  if (!isEmpty(socketObject)) {
    socketObject.close()
  }
  if (!player.Native || !cloudRender.PosViewer) {
    return
  }
  isDestroy = true
  await cloudRender.PosViewer.destroyPosviewer(allDataList)
  // 取消标签的事件监听
  cloudRender.Dispatch.off('PosViewerMarker', markerClick)
  window.removeEventListener('filterPositionList', filterPositionHandler)
  window.removeEventListener('operateSocket', operateSocketHandler)
}

export default {
  create,
  destroy,
}
